import {
  FormatAlignCenter,
  FormatAlignLeft,
  FormatAlignRight,
} from "@mui/icons-material";
import { Autocomplete, Box, Button, Divider, TextField } from "@mui/material";
import { useState } from "react";
import { TypographyFormElement } from "../../../../types";
import { FormElementChangeType } from "../../FormBuilder";

const TypographyVariants = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "subtitle1",
  "subtitle2",
  "body1",
  "body2",
  "caption",
  "overline",
];

type TextAlign = "inherit" | "left" | "center" | "right" | "justify";

export const TypographySideSectionDisplay = ({
  ...props
}: {
  element: TypographyFormElement;
  onChange: (props: FormElementChangeType) => void;
}) => {
  const [alignment, setAlignment] = useState<TextAlign>(
    (props.element.textAlign as TextAlign) || "left",
  );

  const handleAlignmentChange = (newAlignment: TextAlign) => {
    setAlignment(newAlignment);
    props.onChange({
      changeType: "update",
      newElement: {
        ...props.element,
        textAlign: newAlignment,
      } as TypographyFormElement,
    });
  };

  return (
    <>
      <Divider />
      <Box>
        {/* Set Typography Variant */}
        <Autocomplete
          options={TypographyVariants}
          getOptionLabel={(option) => option}
          value={props.element.variant || "body1"}
          onChange={(event, newValue) => {
            if (newValue) {
              props.onChange({
                changeType: "update",
                newElement: {
                  ...props.element,
                  variant: newValue,
                } as TypographyFormElement,
              });
            }
          }}
          renderInput={(params) => (
            <TextField {...params} label="Typography Variant" />
          )}
        />

        {/* Set Text Alignment */}
        <Box
          sx={(t) => ({
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            background: t.palette.grey[100],
            border: `1px solid ${t.palette.grey[300]}`,
            padding: 1,
            borderRadius: "25px",
          })}
        >
          <Button
            variant={alignment === "left" ? "contained" : "outlined"}
            color="inherit"
            onClick={() => handleAlignmentChange("left")}
            startIcon={<FormatAlignLeft />}
            sx={{ flexGrow: 1, border: 0 }}
          >
            Left
          </Button>
          <Button
            variant={alignment === "center" ? "contained" : "outlined"}
            color="inherit"
            onClick={() => handleAlignmentChange("center")}
            startIcon={<FormatAlignCenter />}
            sx={{ flexGrow: 1, border: 0 }}
          >
            Center
          </Button>
          <Button
            variant={alignment === "right" ? "contained" : "outlined"}
            color="inherit"
            onClick={() => handleAlignmentChange("right")}
            startIcon={<FormatAlignRight />}
            sx={{ flexGrow: 1, border: 0 }}
          >
            Right
          </Button>
        </Box>
      </Box>
    </>
  );
};
